import { Select, VStack, Text, HStack, Spinner } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";

/**
 * Выбор слепка базы.
 *
 * База слепков одна на всех, и её восстановление занимает около минуты, в
 * течение которой данных в ней нет вовсе. Поэтому здесь показывается состояние:
 * молча ждать, пока отчёты отвечают отказом, — худший из вариантов.
 */
const SelectBackup = observer(() => {
    const { pageStore } = useStores();

    const selected = pageStore.select_backup;
    const status = pageStore.backup_status;
    const restoring = status === "restoring";

    const hint = () => {
        if (!selected) return null;
        if (restoring) {
            return (
                <HStack spacing={1}>
                    <Spinner size="xs" color="#EEEEEE" />
                    <Text fontSize="11px" color="#EEEEEE">Готовим слепок…</Text>
                </HStack>
            );
        }
        if (status === "error") {
            return (
                <Text fontSize="11px" color="#FF8A80" maxW="200px" textAlign="center">
                    {pageStore.backup_message || "Слепок не готов"}
                </Text>
            );
        }
        // Дату развёрнутого слепка показываем, только если она разошлась с
        // выбранной: значит, кто-то из коллег развернул в общей базе свою.
        if (status === "ready"
            && pageStore.backup_loaded_date
            && pageStore.backup_loaded_date !== selected) {
            return (
                <Text fontSize="11px" color="#FFD54F" maxW="200px" textAlign="center">
                    Развёрнут слепок за {pageStore.backup_loaded_date}
                </Text>
            );
        }
        return null;
    };

    return (
        <VStack
            borderRadius="10px"
            bg="rgb(51, 51, 51)"
            spacing={2}
            padding="4px"
            align="center"
        >
            <Text fontWeight={"600"} fontSize={"12px"} color={"myColor.white"}>
                Слепок:
            </Text>
            <Select
                width="200px"
                border="none"
                color="#EEEEEE"
                borderRadius="10px"
                fontWeight={600}
                fontSize="14px"
                placeholder="Из БД"
                value={selected || ""}
                isDisabled={restoring}
                onChange={(e) => {
                    const selectedValue = e.target.value;
                    pageStore.updateSelectedBackup(selectedValue || "");
                }}
            >
                {pageStore.all_backups
                    .map((item, index) => (
                        <option
                            key={index}
                            value={item}
                            style={{ background: "#0C0C0C", color: "#EEEEEE" }}
                        >
                            {item}
                        </option>
                    ))}
            </Select>
            {hint()}
        </VStack>
    );
});

export default SelectBackup;
